import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export const getOptionsFromCustomersAsSupplier = (
  customersAsSuppliers: CustomerResponseBodyV2[] | Nullish
): Option[] => {
  if (isNil(customersAsSuppliers)) {
    return [];
  }

  return customersAsSuppliers.map((customersAsSupplier) => ({
    label: customersAsSupplier.businessInfo?.businessInfo?.tradeName ?? '',
    value: customersAsSupplier.id,
  }));
};
